const global = {
  'your-queues': 'Twoje kolejki',
  'your-visits': 'Twoje miejsca w kolejce',
  'back-to-prev-page': 'Wróć do poprzedniej strony',
  'admin-panel': 'Panel administratora',
  'cancel': 'Anuluj',
  'confirm': 'Potwierdź',
  'confirmation': 'Potwierdzenie',
  'expand-menu': 'Rozwiń menu',
  'collapse-menu': 'Zwiń menu',
  'no-result': 'Brak wyników',
  'loading': 'Ładowanie ...',
  'refresh': 'Odśwież',
  'search': 'Szukaj',
  'forbidden': 'Brak dostępu!',
  unknownError: 'Wystąpił nieznany błąd!'
};

export default global;
